import React, { useState, useEffect } from 'react'
import Main from './MainCall2'
import { getUserDetailsByNumberExotel } from '../../AdminActionCreator.component';
import UserLogo from '../../../../../images/rewampimages/user.png'
import borrower1 from '../../../../../images/borrower1.png'
import moment from 'moment';
import Skeleton from '@mui/material/Skeleton';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { getcallTemplatecampaignsByData, getPreviouscallLogsHisotryByNumber } from '../../CommunicationModule/ActionCreator'
import CallIcon from '@mui/icons-material/Call';

export default function callDashboard() {
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [userData, setUserData] = useState({})
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [CampaignId, setCampaignId] = useState(null);
    const [showData, setShowData] = useState(false)
    const [loader, setLoader] = useState(false)
    const [inputNumber, setInputNumber] = useState('')
    const [selectedCampaign, setselectedCampaign] = useState('')
    const [campaignList, setcampaignList] = useState([])
    const [callData, setcallData] = useState({})
    const handleNumber = (data) => {
        console.log("data", data)
        const str = data?.additionalParams?.length > 0 ? JSON.parse(data?.additionalParams) : "";
        console.log("str",str)
        setCampaignId(str?.campaignId || null);

        if (str.callType == "outbound.manual.dial" || str.callType == "inbound.call.dial" ) {
            setPhoneNumber(str?.phone || null);
        } else {
            const phone = str?.customerInfo?.length > 0 ? JSON.parse(str?.customerInfo) : "";
            setPhoneNumber(phone?.phone1 || null);
        }
      
    };



    const handleclosePopup = () => {
        setShowData(false)
        setUserData({});
        setPhoneNumber(null)
        setCampaignId(null)
    }

    useEffect(() => {
        if (!phoneNumber || !CampaignId) return;

        // let campaignId = 0;
        setShowData(true)
        setLoader(true)
        getUserDetailsByNumberExotel(phoneNumber, CampaignId, (callback) => {
            console.log("call", callback)
            setLoader(false)
            if (callback?.status == 200 && callback?.message == 'success') {
                setUserData(callback?.data);
            } else {
                setUserData({});
            }
        });
        getPreviouscallLogsHisotryByNumber(phoneNumber, (callback) => {
            console.log("call", callback)
            setLoader(false)
            if (callback?.status == 200 && callback?.message == 'success') {
                setcallData(callback?.data);
            } else {
                setcallData({});
            }
        });
    }, [phoneNumber, CampaignId]);


    useEffect(() => {
        getcallTemplatecampaignsByDataFn()
    }, [])


    const handleSearch = () => {
        if (inputNumber?.length == 10) {
            setPhoneNumber(inputNumber)
        } else {
            setPopup({ show: true, popupStatus: "Phone Number should be of 10 Digits" })
            removePopup()
        }
        if (selectedCampaign?.length !== 0) {
            setCampaignId(selectedCampaign)
        } else {
            setPopup({ show: true, popupStatus: "Please Select a Campaign" })
            removePopup()
        }
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const getcallTemplatecampaignsByDataFn = () => {
        getcallTemplatecampaignsByData(true, callback => {
            setcampaignList(callback?.data)
        })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    return (
        <>
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ''
            }
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="row">
                    <div className="col-sm-4 col-xs-12">
                        <Main handleNumber={handleNumber} />
                    </div>
                    <div className="col-sm-8 col-xs-12">

                        <div className='row'>
                            <div className="col-sm-3 col-xs-12">
                                <label htmlFor="">Mobile No.</label>
                                <input type='number' className='form-control' value={inputNumber} onChange={(e) => setInputNumber(e.target.value)} />
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <label htmlFor="">Campaign</label>
                                <select className='form-control' value={selectedCampaign} onChange={(e) => setselectedCampaign(e.target.value)} >
                                    <option value={""}>Select Campagin</option>
                                    {
                                        campaignList?.length > 0 ? campaignList?.map((val, id) => {
                                            return (
                                                <option value={val?.campaignId}>{val?.campaignName}</option>
                                            )
                                        })
                                            : ''}
                                   
                                </select>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <button className='btn btn-primary' onClick={() => handleSearch()} style={{ marginTop: '22px', padding: '9px' }}><i className='fa fa-search'></i></button>
                            </div>
                        </div>
                        <hr />
                        {
                            showData ?
                                !loader ?
                                    <div className="details-new" style={{
                                        borderRadius: '20px',
                                        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px', padding: '10px'
                                    }}>
                                        <i className='fa fa-times' style={{ color: "red", float: 'right', cursor: 'pointer' }} onClick={() => handleclosePopup()}></i>
                                        {
                                            userData && Object.keys(userData)?.length > 0 ?
                                                <>
                                                    <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey' }}>
                                                        <div className="details-head">
                                                            <div className="row">
                                                                <div className="col-sm-11 col-xs-11">
                                                                    <div style={{ marginTop: '6px' }}>
                                                                        <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                                        <b style={{ marginTop: '14px' }}>Personal Information</b>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                                            <div className="row" >
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Application Id</label>
                                                                    <p>{userData?.applicationId || "-"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>First Name</label>
                                                                    <p>{userData?.firstName || "-"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Last Name</label>
                                                                    <p>{userData?.lastName || "-"}</p>
                                                                </div>

                                                            </div>
                                                            <div className="row" >

                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Email Id</label>
                                                                    <p>{userData?.email || "N/A"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Primary Number</label>
                                                                    <p>{userData?.primaryNumber || "N/A"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Alternate Number</label>
                                                                    <p>{userData?.alternativeNumber || "-"}</p>
                                                                </div>

                                                            </div>
                                                            <div className="row" >
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Gender</label>
                                                                    <p>{userData?.gender || "N/A"}</p>
                                                                </div>

                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>D.O.B</label>
                                                                    <p>{userData?.dob || "-"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Designation</label>
                                                                    <p>{userData?.designation || "-"}</p>
                                                                </div>


                                                            </div>
                                                            <div className="row" >

                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Refrence Number 1</label>
                                                                    <p>{userData?.refNumber1 || "N/A"}</p>
                                                                </div>

                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Refrence Number 2</label>
                                                                    <p>{userData?.refNumber2 || "N/A"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Refrence Number 3</label>
                                                                    <p>{userData?.refNumber3 || "N/A"}</p>
                                                                </div>


                                                            </div>
                                                            <div className="row" >
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Form Status</label>
                                                                    <p>{userData?.formStatus || "N/A"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Created Date</label>
                                                                    <p>{userData?.createdDate || "N/A"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Last Login Date</label>
                                                                    <p>{userData?.lastLoginDate || "N/A"}</p>
                                                                </div>


                                                            </div>
                                                            <div className="row" >
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Organization Name</label>
                                                                    <p>{userData?.organizationName || "-"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Salary</label>
                                                                    <p>{userData?.salary || "-"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Approve Amount</label>
                                                                    <p>{userData?.approvalAmount || "-"}</p>
                                                                </div>

                                                            </div>
                                                            <div className="row" >
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>Tenure</label>
                                                                    <p>{userData?.tenure || "-"}</p>
                                                                </div>
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>KYC</label>
                                                                    <p>{userData?.kyc || "-"}</p>
                                                                </div>

                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>E-Sign</label>
                                                                    <p>{userData?.esign || "-"}</p>
                                                                </div>
                                                               
                                                            </div>
                                                            <div className="row" >
                                                               
                                                                <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                    <label>E-Nach</label>
                                                                    <p>{userData?.enach || "-"}</p>
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                    {
                                                        userData?.emiDetails?.length > 0 ?

                                                            <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey' }}>
                                                                <div className="details-head">
                                                                    <div className="row">
                                                                        <div className="col-sm-11 col-xs-11">
                                                                            <div style={{ marginTop: '6px' }}>
                                                                                <img src={borrower1} style={{ width: '20px' }} /> &nbsp;
                                                                                <b style={{ marginTop: '14px' }}>EMI Information</b>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>

                                                                    <div className="row" >

                                                                        <div className='overflow-auto' style={{ margin: '0 10px' }}>
                                                                            <table className='phocket-table'>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className='text-center'>DPD Days</th>
                                                                                        <th className='text-center'>Overdue Amount</th>
                                                                                        <th className='text-center'>EMI Status</th>
                                                                                        <th className='text-center'>EMI Amount</th>
                                                                                        <th className='text-center'>Due Date</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        userData?.emiDetails?.map((val, id) => {
                                                                                            return (
                                                                                                <tr key={id}>
                                                                                                    <td className='text-center'>{val?.dpdDays || "-"}</td>
                                                                                                    <td className='text-center'>{val?.overdueAmount || "-"}</td>
                                                                                                    <td className='text-center'>{val?.emiStatus || "-"}</td>
                                                                                                    <td className='text-center'>{val?.emiAmount || "-"}</td>
                                                                                                    <td className='text-center'>{val?.dueDate || "-"}</td>
                                                                                                </tr>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </tbody>

                                                                            </table>
                                                                        </div>

                                                                    </div>


                                                                </div>
                                                            </div>
                                                            : ""}
                                                    {
                                                        Object.keys(callData)?.length > 0 ?

                                                            <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey' }}>
                                                                <div className="details-head">
                                                                    <div className="row">
                                                                        <div className="col-sm-11 col-xs-11">
                                                                            <div style={{ marginTop: '6px' }}>
                                                                                {/* <img src={borrower1} style={{ width: '20px' }} /> &nbsp; */}
                                                                                <CallIcon style={{ width: '20px' }} />&nbsp;

                                                                                <b style={{ marginTop: '14px' }}>Previous Call Information</b>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>

                                                                    <div className="row" >
                                                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                            <label>Agent Id</label>
                                                                            <p>{callData?.agentID || "N/A"}</p>
                                                                        </div>
                                                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                            <label>Call Status</label>
                                                                            <p>{callData?.callStatus || "N/A"}</p>
                                                                        </div>
                                                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                            <label>Disposition</label>
                                                                            <p>{callData?.disposition || "N/A"}</p>
                                                                        </div>

                                                                    </div>
                                                                    <div className="row" >
                                                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                            <label>Call Duration</label>
                                                                            <p>{callData?.callDuration || "N/A"}</p>
                                                                        </div>
                                                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                            <label>Call Start</label>
                                                                            <p>{moment(callData?.callStart).format("DD-MM-YYYY HH:MM:SS") || "N/A"}</p>
                                                                        </div>
                                                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                                                            <label>Call End</label>
                                                                            <p>{moment(callData?.callEnd).format("DD-MM-YYYY HH:MM:SS") || "N/A"}</p>
                                                                        </div>

                                                                    </div>


                                                                </div>
                                                            </div>
                                                            : ""}
                                                </>
                                                :
                                                <h4><i>No Data Found</i></h4>
                                        }
                                    </div>
                                    :
                                    <Skeleton variant="rectangular" width={"100%"} height={800} />
                                : ''}
                    </div>
                </div>
            </div>





        </>
    )
}
